import { Text } from '@mantine/core';
import { Variable } from 'components/Variable';
import { tKeysLoose } from 'locales/index';
import { useTranslation } from 'locales/logic';
import { isNullish } from 'remeda';
import type { AutomationCondition, CreateAutomationVariables } from '../../../api';
import { useGetFieldDefinition } from '../../AutomationWizard';
import { ConditionActionBox } from './ConditionActionBox';

type ConditionBoxProps = {
  condition: AutomationCondition;
  model: CreateAutomationVariables['targetModel'];
};

export const ConditionRow = ({ condition, model }: ConditionBoxProps) => {
  const { t } = useTranslation();
  const { fieldName, operator, operand } = condition;

  const field = useGetFieldDefinition(fieldName, model);

  if (isNullish(field)) return null;
  if (isNullish(operator) || isNullish(fieldName)) return null;

  return (
    <ConditionActionBox>
      {field.icon}
      <Text>{t(tKeysLoose.AUTOMATION.CONDITIONS.IF)}</Text>
      <Variable color="coral">{field.label}</Variable>
      <Text>
        {t(
          tKeysLoose.AUTOMATION.OPERATORS[operator.toUpperCase().replaceAll('_', '')],
        ).toLowerCase()}
      </Text>
      {operand && <Variable color="blue">{operand}</Variable>}
    </ConditionActionBox>
  );
};
